import React from 'react';
import { createClient } from '@supabase/supabase-js';
import { API_BASE, apiFetch } from '@/lib/api';

const VITE_API_BASE = import.meta.env.VITE_API_BASE as string | undefined;
const VITE_SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const VITE_SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;
const VITE_GIT_COMMIT_SHA = import.meta.env.VITE_GIT_COMMIT_SHA as string | undefined;

export default function Status() {
  const [session, setSession] = React.useState<any>(null);
  const [meStatus, setMeStatus] = React.useState<number | null>(null);
  const [campaignsStatus, setCampaignsStatus] = React.useState<number | null>(null);

  React.useEffect(() => {
    try {
      if (VITE_SUPABASE_URL && VITE_SUPABASE_ANON_KEY) {
        const supabase = createClient(VITE_SUPABASE_URL, VITE_SUPABASE_ANON_KEY, { auth: { persistSession: true } });
        supabase.auth.getSession().then(({ data }) => setSession(data.session));
      }
    } catch {}
  }, []);

  React.useEffect(() => {
    (async () => {
      try {
        const me = await apiFetch('/users/me', { method: 'GET' });
        setMeStatus(me.status);
      } catch {
        setMeStatus(-1);
      }
      try {
        const c = await apiFetch('/campaigns', { method: 'GET' });
        setCampaignsStatus(c.status);
      } catch {
        setCampaignsStatus(-1);
      }
    })();
  }, []);

  // Get commit SHA from build-time injection
  const frontendCommitSha = VITE_GIT_COMMIT_SHA || 'unknown';

  return (
    <div style={{ padding: 16, fontFamily: 'system-ui, -apple-system, sans-serif' }}>
      <h1>Status</h1>
      <div>API_BASE: {API_BASE}</div>
      <div>VITE_API_BASE: {VITE_API_BASE || '(unset)'}</div>
      <div>VITE_SUPABASE_URL: {VITE_SUPABASE_URL || '(unset)'}</div>
      <div>Frontend Commit SHA: {frontendCommitSha}</div>
      <div>session: {session ? 'true' : 'false'}</div>
      <div>/api/users/me: {meStatus}</div>
      <div>/api/campaigns: {campaignsStatus}</div>
    </div>
  );
}


